import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { Line } from 'react-chartjs-2';
import { useApi } from '~/contexts';
import { colors } from '~/styles';
import { dateFormats } from '~/utils';
import { ChartWrapper, Loading } from './components';

export default function Weekly() {
  const api = useApi();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    const now = moment();
    const end = now.startOf('isoWeek').subtract(1, 'day').format(dateFormats.isoDate);
    const start = now.subtract(1, 'year').format(dateFormats.isoDate);
    const getData = async () => {
      setIsLoading(true);
      setData();
      try {
        const { data } = await api.admin.reports.getWeeklyActiveUsers({ start, end });
        setData(data);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
    return getData.cancel;
  }, [api]);

  const chartData = useMemo(() => {
    if (!data) {
      return null;
    }
    return {
      labels: data.map((item) => item.date),
      datasets: [
        {
          label: 'Users',
          data: data.map((item) => item.count),
          backgroundColor: colors.primary25,
          borderColor: colors.primary,
          fill: true,
          tension: 0.4,
        },
      ],
    };
  }, [data]);

  const options = {
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'month',
        },
      },

      y: {
        ticks: {
          precision: 0,
        },
      },
    },
    plugins: {
      title: {
        display: true,
        text: 'Weekly Activity (1 year)',
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: ([tooltip]) => {
            const start = moment(tooltip.parsed.x);
            const end = start.clone().add(6, 'days');
            return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
          },
        },
      },
    },
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ChartWrapper>
      <Line data={chartData} options={options} />
    </ChartWrapper>
  );
}
